import ErrorPage from './ErrorPage.vue';

export default ErrorPage;
